import { Directive, OnInit, OnDestroy, Input, EventEmitter, Output, ElementRef, HostListener } from '@angular/core';
import { UploaderOptions, UploadInput, UploadOutput, NgUploaderService } from 'ngx-uploader';
import { Subscription } from 'rxjs';
import { CustomFileHandlerService } from './custom-file-handler.service';

@Directive({
  selector: '[ivCustomFileDrop]'
})
export class CustomFileDropDirective implements OnInit, OnDestroy {

  @Input() options: UploaderOptions;
  @Input() uploadInput: EventEmitter<UploadInput>;
  @Output() uploadOutput: EventEmitter<UploadOutput>;

  upload: NgUploaderService;
  el: HTMLInputElement;

  _sub: Subscription[];

  constructor(public elementRef: ElementRef, private customFileService: CustomFileHandlerService) {
    this.uploadOutput = new EventEmitter<UploadOutput>();
  }

  ngOnInit() {
    this._sub = [];
    const concurrency = this.options && this.options.concurrency || Number.POSITIVE_INFINITY;
    const allowedContentTypes = this.options && this.options.allowedContentTypes || ['*'];
    // Below values are availabe as last two params of NgUploaderService in latest version
    // const maxUploads = this.options && this.options.maxUploads || Number.POSITIVE_INFINITY;
    // const maxFileSize = this.options && this.options.maxFileSize || Number.POSITIVE_INFINITY;
    this.upload = new NgUploaderService(concurrency, allowedContentTypes);

    this.el = this.elementRef.nativeElement;

    this._sub.push(
      this.upload.serviceEvents.subscribe((event: UploadOutput) => {
        this.uploadOutput.emit(event);
      })
    );

    if (this.uploadInput instanceof EventEmitter) {
      this._sub.push(this.upload.initInputEvents(this.uploadInput));
    }

    this.el.addEventListener('drop', this.stopEvent, false);
    this.el.addEventListener('dragenter', this.stopEvent, false);
    this.el.addEventListener('dragover', this.stopEvent, false);
  }

  ngOnDestroy() {
    this._sub.forEach(sub => sub.unsubscribe());
  }

  stopEvent = (e: Event) => {
    e.stopPropagation();
    e.preventDefault();
  }

  @HostListener('drop', ['$event'])
  public onDrop(e: any) {
    e.stopPropagation();
    e.preventDefault();

    const event: UploadOutput = { type: 'drop' };
    this.uploadOutput.emit(event);
    this.customFileService.manipulateFiles(e.dataTransfer.files).then(files => {
      this.upload.handleFiles(files);
    }).catch(err => console.log(err));
  }

  @HostListener('dragover', ['$event'])
  public onDragOver(e: Event) {
    if (!e) {
      return;
    }

    const event: UploadOutput = { type: 'dragOver' };
    this.uploadOutput.emit(event);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(e: Event) {
    if (!e) {
      return;
    }

    const event: UploadOutput = { type: 'dragOut' };
    this.uploadOutput.emit(event);
  }

}
